import { Html5Entities } from 'html-entities';

export const StringHelpers = {
  trimString: (str, no_words, separator = ' ') => {
    if (str.split(' ').length < no_words) {
      separator = ' ';
    }

    return (
      str
        .split(' ')
        .splice(0, no_words)
        .join(' ') + separator
    );
  },

  appendLeadingZeroes: n => (n <= 9 ? `0${n}` : n),

  escape: str => {
    const htmlEntities = new Html5Entities();
    return htmlEntities.encode(str);
  },

  unescape: str => {
    const htmlEntities = new Html5Entities();
    return htmlEntities.decode(str);
  },

  strip: html => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  },

  ucfirst: str => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },
};

export default StringHelpers;
